﻿window.cColonne = function (vueColonne) {

    this.mGetItemFromNom = function (nomColonne, idTable) {
        var result = null;
        vueColonne.forEach(function (colonne) { if (colonne.nom == nomColonne && colonne.id_table == idTable) result = colonne; });
        return result
    }

    this.mGetItem = function (idTable, idColonne) {
        var result = null;
        vueColonne.forEach(function (colonne) { if (colonne.id_colonne == idColonne && colonne.id_table == idTable) result = colonne; });
        return result
    }

    this.mGetDescription = function (idTable, idColonne) {
        var col = this.mGetItem(idTable, idColonne)
        if (col.description && col.description.length > 0) { return col.description }
        else { return col.nom }
    }

    this.mGetDescriptionFormat = function (idTable, idColonne) {
        return this.mGetDescription(idTable, idColonne).substring(0, 1).toUpperCase() + this.mGetDescription(idTable, idColonne).substring(1)
    }

}